var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___ZDNEM0",
  "S7": "ProfileCardUserInfo.module__nameRow___ZDNEM0",
  "oo": "ProfileCardUserInfo.module__nameButton___ZDNEM0",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___ZDNEM0",
  "fC": "ProfileCardUserInfo.module__badgeContainer___ZDNEM0",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___ZDNEM0",
  "qJ": "ProfileCardUserInfo.module__belowUsername___ZDNEM0",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___ZDNEM0",
  "Fj": "ProfileCardUserInfo.module__usernameRow___ZDNEM0",
  "xO": "ProfileCardUserInfo.module__usernameButton___ZDNEM0",
  "hI": "ProfileCardUserInfo.module__pronouns___ZDNEM0",
  "sM": "ProfileCardUserInfo.module__srOnly___ZDNEM0",
};

module.exports = exports;
